import { render } from "./onboarding-empty.vue?vue&type=template&id=8187062e&lang=pug"
import script from "./onboarding-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./onboarding-empty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__